// @ts-nocheck
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {BaseButton} from "@/components";
import iconBell from "../../assets/images/icon-bell.svg";
import iconBellBlack from "../../assets/images/icon-bell-black.svg";

const NotificationPrompt = ({
  onClose,
  onRequestPermission,
  pushSupported,
  userConsent = "default",
  isSubscribing = false,
  error = null,
}) => {
  const {t} = useTranslation();

  if (!pushSupported || userConsent === "granted") return null;

  return (
    <div className="flex flex-col items-center gap-4 w-full text-center py-2">
      {/* Top accent bar */}
      <div className="h-[3px] bg-[linear-gradient(90deg,rgba(250,84,0,1)_0%,rgba(215,50,168,1)_100%)] w-[calc(100%+3rem)] -mt-5 mb-2 rounded-t-[var(--radius-lg)]" />

      {/* Icon */}
      <div className="w-14 h-14 rounded-full bg-[rgba(215,50,168,0.12)] border border-[rgba(215,50,168,0.25)] flex items-center justify-center">
        <img src={iconBell} alt="" className="w-7 h-7" />
      </div>

      {/* Title */}
      <p className="m-0 text-[var(--font-h3)] font-bold text-[var(--color-text)] leading-tight">
        {t("notifications.prompt.title", "Recibe notificaciones importantes")}
      </p>

      {/* Description */}
      <p className="m-0 text-[var(--font-body)] text-[var(--color-text-secondary)] leading-relaxed max-w-xs">
        {t(
          "notifications.prompt.description",
          "Activa las notificaciones para recibir alertas sobre promociones especiales, resultados de juegos y novedades."
        )}
      </p>

      {error && (
        <p className="m-0 text-[var(--font-caption)] text-[var(--color-danger)]">
          {t("notifications.prompt.error", "Ocurrió un error al activar las notificaciones")}
        </p>
      )}

      {/* Actions */}
      <div className="flex gap-3 w-full mt-1">
        <BaseButton
          variant="outline"
          onClick={onClose}
          className="flex-1"
        >
          {t("notifications.prompt.later", "Más tarde")}
        </BaseButton>
        <BaseButton
          variant="primary"
          loading={isSubscribing}
          onClick={onRequestPermission}
          className="flex-1"
          leftIcon={<img src={iconBellBlack} alt="" className="w-5 h-5" />}
        >
          {isSubscribing
            ? t("notifications.prompt.activating", "Activando...")
            : t("notifications.prompt.enable", "Activar notificaciones")}
        </BaseButton>
      </div>
    </div>
  );
};

NotificationPrompt.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onRequestPermission: PropTypes.func.isRequired,
  pushSupported: PropTypes.bool.isRequired,
  userConsent: PropTypes.string,
  isSubscribing: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default NotificationPrompt;
